import { z, ZodType } from 'zod';

export type IdResponse = {
	id: number;
};

export const idResponseSchema: ZodType<IdResponse> = z.object({
	id: z.number(),
});
